


import React, { useEffect, useState } from "react";
import useAxios from "../../utils/useAxios";
import { hideModal, showModal } from "../../utils/modalUtility";
import Pagination from "../common/pagination";

const Contributions = () => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [editData, setEditData] = useState({});

  const [loading, setLoading] = useState(false);
  const [contribution, setContribution] = useState([]);
  const [filterStatus, setFilterStatus] = useState("");
  const [expandedId, setExpandedId] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const axiosAPI = useAxios();

  async function fetchContribution() {
    try {
      setLoading(true);
      let url = `/api/contribution/get-contribution?page=${page}`;
      if (filterStatus) {
        url += `&status=${filterStatus}`;
      }
      const response = await axiosAPI.get(url);
      setContribution(response?.data?.contribution);
      setTotalPages(response?.data?.totalPages);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      // Always turn off loading, whether success or error
      setLoading(false);
    }
  }

  const truncateText = (text, maxLength = 40) => {
    if (!text) return "";
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };


  useEffect(() => {
    fetchContribution();
  }, [page, filterStatus]);

  async function changeContributionStatus(status, contributionId) {
    console.log("Current Status:", status);

    try {
      const isConfirmed = window.confirm(
        "Are you sure you want to change the contribution status?"
      );
      if (!isConfirmed) return;

      await axiosAPI.put(
        `/api/contribution/change-contribution-status/${contributionId}`,
        { status }
      );

      fetchContribution();

      window.notifyMessage(
        "Success",
        "Contribution status changed successfully",
        "success"
      );
    } catch (error) {
      console.error("Error changing contribution status:", error);
      window.notifyMessage(
        "Error",
        "Failed to change contribution status. Please try again.",
        "danger"
      );
    }
  }


  //edit contribution

  async function handleUpdateContribution(e) {
    e.preventDefault();

    try {
      await axiosAPI.put(
        `/api/contribution/update-contribution/${editData.id}`,
        editData
      );

      window.notifyMessage(
        "Success",
        "Contribution updated successfully",
        "success"
      );

      // 🔥 Close Modal
      const modalElement = document.getElementById("editContributionModal");
      const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
      modalInstance.hide();

      fetchContribution();
    } catch (error) {
      window.notifyMessage(
        "Error",
        "Failed to update contribution",
        "danger"
      );
    }
  }



  const openEditModal = (contributionId, currentStatus) => {
    setIsEditMode(true);
  };

  const handleDelete = async (id) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this?");
    if (!isConfirmed) return;

    try {
      const response = await axiosAPI.delete(`/api/contribution/delete-contribution/${id}`);
      window.notifyMessage("Success", "Deleted successfully", "success");
      fetchContribution();
    } catch (error) {
      console.error("Error deleting:", error);
      window.notifyMessage(
        "Error",
        "An error occurred while deleting.",
        "danger"
      );
    }
  };

  const formatDate = (date) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  // Output: 31 Jan 2026
  useEffect(() => {
    fetchContribution();
  }, []);

  return (



    <div className="container">
      <div
        className="modal fade"
        id="editContributionModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">Edit Contribution</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body">
              <form onSubmit={handleUpdateContribution}>

                {/* User Info (Read Only) */}
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Full Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData.full_name || ""}
                      readOnly
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Email</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData.email || ""}
                      readOnly
                    />
                  </div>
                </div>

                {/* Type */}
                <div className="mb-3">
                  <label className="form-label">Type</label>
                  <select
                    className="form-select"
                    value={editData.type || ""}
                    onChange={(e) =>
                      setEditData({ ...editData, type: e.target.value })
                    }
                  >
                    <option value="restaurant">Restaurant</option>
                    <option value="recipe">Recipe</option>
                    <option value="product">Product</option>
                  </select>
                </div>

                {/* Link */}
                <div className="mb-3">
                  <label className="form-label">Link</label>
                  <textarea
                    className="form-control"
                    rows="2"
                    value={editData.link || ""}
                    onChange={(e) =>
                      setEditData({ ...editData, link: e.target.value })
                    }
                  />
                </div>

                {/* Description */}
                <div className="mb-3">
                  <label className="form-label">Description</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    value={editData.description || ""}
                    onChange={(e) =>
                      setEditData({ ...editData, description: e.target.value })
                    }
                  />
                </div>

                {/* Status */}
                <div className="mb-3">
                  <label className="form-label">Status</label>
                  <select
                    className="form-select"
                    value={editData.status || ""}
                    onChange={(e) =>
                      setEditData({ ...editData, status: e.target.value })
                    }
                  >
                    <option value="pending">Pending</option>
                    <option value="approved">Approved</option>
                    <option value="declined">Declined</option>
                  </select>
                </div>

                {/* Rejection Reason */}
                
                  <div className="mb-3">
                    <label className="form-label">Rejection Reason</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      placeholder="Enter rejection reason"
                      value={editData.admin_comment || ""}
                      onChange={(e) =>
                        setEditData({
                          ...editData,
                          admin_comment: e.target.value,
                        })
                      }
                    />
                  </div>
            

                {/* Points */}
                <div className="mb-3">
                  <label className="form-label">Points</label>
                  <input
                    type="number"
                    className="form-control"
                    value={editData.points || 0}
                    onChange={(e) =>
                      setEditData({ ...editData, points: e.target.value })
                    }
                  />
                </div>

                <button type="submit" className="btn btn-primary btn-sm">
                  Update Contribution
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className="page-inner">
        <div className="d-flex justify-content-between align-items-center mb-4 flex-column flex-md-row">
            <div className="d-flex gap-3 mb-3 mb-md-0">
                <select
                  className="form-select"
                  value={filterStatus}
                  onChange={(e) => {
                    setFilterStatus(e.target.value);
                    setPage(1);
                  }}
                >
                  <option value="">All Status</option>
                  <option value="pending">Pending</option>
                  <option value="approved">Approved</option>
                  <option value="declined">Declined</option>
                </select>
            </div>
        </div>

        {/* Feedback Table */}
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">
                  All Contributions ({contribution?.length})
                </h4>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Type</th>
                        <th>Link</th>
                        <th>Email</th>
                        <th>Name</th>
                        <th>Status</th>
                        <th>Description</th>
                        <th>Admin Comment</th>
                        <th>Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="5" className="text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : contribution?.length === 0 ? (
                        <tr>
                          <td colSpan="5" className="text-center">
                            No Contributions found.
                          </td>
                        </tr>
                      ) : (
                        contribution &&
                        contribution?.map((contribution) => (
                          <tr key={contribution.id}>
                            <td>{contribution?.type}</td>
                            {/* <td>{contribution?.link}</td> */}
                            <td
                              style={{ cursor: "pointer", maxWidth: "250px" }}
                              onClick={() =>
                                setExpandedId(expandedId === contribution.id ? null : contribution.id)
                              }
                            >
                              {expandedId === contribution.id
                                ? contribution?.link
                                : truncateText(contribution?.link, 40)}
                            </td>
                            <td>{contribution?.email}</td>
                            <td>{contribution?.full_name}</td>
                            <div>
                              <td>
                                <select
                                  className="form-select"
                                  value={contribution.status}
                                  onChange={(e) =>
                                    changeContributionStatus(e.target.value, contribution.id)
                                  }
                                >
                                  <option value="pending">Pending</option>
                                  <option value="approved">Approved</option>
                                  <option value="declined">Declined</option>
                                </select>

                              </td>
                            </div>

                            <td>{contribution?.description}</td>

                            <td>{contribution?.admin_comment}</td>

                    
                            {/* <td style={{ color: "red", maxWidth: "200px" }}>
                              {contribution.status === "declined"
                                ? contribution.rejection_reason || "Invalid or irrelevant submission"
                                : "-"}
                            </td> */}
                            <td>{formatDate(contribution?.created_at)}</td>
                            <td>
                              <button
                                className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                data-bs-toggle="modal"
                                data-bs-target="#editContributionModal"
                                onClick={() => setEditData(contribution)}
                              >
                                <i className="fas fa-edit"></i>
                              </button>

                              <button
                                className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                onClick={() => handleDelete(contribution.id)}
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>

                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <Pagination totalPages={totalPages} setPage={setPage} page={page} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contributions;
